module.exports = __webpack_public_path__ + "static/media/footer__logo-twint.86531095.svg";